var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"maintenance"},[_c('div',{staticClass:"content"},[_c('h1',[_vm._v("Regresaremos pronto!")]),_c('p',[_vm._v("La aplicación se encuentra en mantenimiento programado. Por favor regresa más tarde.")]),_c('p',[_vm._v("Horario de mantenimiento: Lunes 18 de noviembre a las 18:00 a Martes 19 de noviembre a las 02:00.")])])])
}]

export { render, staticRenderFns }